<template>
  <div class="butler-qrcode-page">
    <div class="qrcode-card">
      <h2 class="title">{{ title }}</h2>
      <p class="subtitle">长按二维码识别，添加企业微信</p>
      <div class="qrcode-wrap">
        <img
          v-if="qrUrl"
          class="qrcode-img"
          :src="qrUrl"
          alt="企业微信二维码"
          referrerpolicy="no-referrer"
        />
        <div v-else class="qrcode-empty">暂无二维码</div>
      </div>
      <p class="tip">长按上方二维码即可识别添加</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButlerQrcode',
  data() {
    return {
      qrUrl: '',
      title: '联系酒店服务管家'
    }
  },
  created() {
    const query = this.$route.query || {}
    this.qrUrl = query.qrUrl || ''
    if (query.title) {
      this.title = decodeURIComponent(query.title)
    }
    if (query.title) {
      document.title = this.title
    }
  }
}
</script>

<style lang="scss" scoped>
.butler-qrcode-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #F7F5FC 0%, #F0FBFD 100%);
  padding: 40px 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.qrcode-card {
  width: 100%;
  background: #fff;
  border-radius: 16px;
  padding: 28px 20px 32px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  text-align: center;

  .title {
    font-size: 18px;
    font-weight: bold;
    color: #232773;
    margin: 0 0 8px 0;
  }

  .subtitle {
    font-size: 13px;
    color: #666;
    margin: 0 0 24px 0;
  }

  .qrcode-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
  }

  .qrcode-img {
    width: 260px;
    height: 260px;
    display: block;
    object-fit: contain;
    -webkit-touch-callout: default;
    user-select: none;
    pointer-events: auto;
  }

  .qrcode-empty {
    color: #999;
    font-size: 14px;
  }

  .tip {
    margin: 20px 0 0 0;
    font-size: 13px;
    color: #999;
  }
}
</style>
